import { jsx as _jsx } from "react/jsx-runtime";
import { Score } from "./Score";
export const ScoreBadge = ({ score, size = "sm", sx }) => {
    // [JIRA KS-360] use scoring system to determine icon display
    if (!score || score.scoringSystem.name !== "Bullet Score") {
        return null;
    }
    return _jsx(Score, { scoreValue: score.value, scoringSystem: score.scoringSystem, size: size, sx: { ...sx } });
};
//# sourceMappingURL=ScoreBadge.js.map